<div class="p-3 bg-white" [formGroup]="editForm" style="min-width: 480px; font-size: 0.88rem;">
  <div class="border-bottom pb-2 mb-3">
    <h3 class="h5 m-0 fw-bold text-dark">✏️ Modificar Registro Catálogo UDC</h3>
    <span class="small text-muted font-monospace">Registro Indexado ID DB: {{ data.id }}</span>
  </div>

  <div class="row g-2 mb-3">
    <div class="col-md-6">
      <div class="form-floating">
        <input type="text" class="form-control bg-light font-monospace" id="editSys" formControlName="udcSystem">
        <label for="editSys">Código Sistema (Congelado)</label>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-floating">
        <input type="text" class="form-control bg-light font-monospace" id="editKey" formControlName="udcKey">
        <label for="editKey">Categoría Clave (Congelado)</label>
      </div>
    </div>
  </div>

  <div class="form-floating mb-3">
    <input type="text" class="form-control text-uppercase fw-semibold" id="editDesc" formControlName="description" placeholder="Desc"
           [ngClass]="{'is-invalid': editForm.get('description')?.touched && editForm.get('description')?.invalid}">
    <label for="editDesc">Descripción Larga del Catálogo *</label>
  </div>

  <div class="row g-2 mb-3">
    <div class="col-md-6">
      <div class="form-floating">
        <input type="text" class="form-control text-uppercase font-monospace" id="editV1" formControlName="strValue1" placeholder="V1">
        <label for="editV1">Valor Alfanumérico 1</label>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-floating">
        <input type="text" class="form-control text-uppercase font-monospace" id="editV2" formControlName="strValue2" placeholder="V2">
        <label for="editV2">Valor Alfanumérico 2</label>
      </div>
    </div>
  </div>

  <div class="form-check form-switch mb-3 ps-5">
    <input class="form-check-input" type="checkbox" id="editBool" formControlName="booleanValue">
    <label class="form-check-label fw-bold text-secondary" for="editBool">Clave de Catálogo Activa y Disponible</label>
  </div>

  <div class="d-flex justify-content-end gap-2 border-top pt-2">
    <button type="button" class="btn btn-sm btn-light border" (click)="dialogRef.close()">Cancelar</button>
    <button type="button" class="btn btn-sm btn-info text-white px-4 fw-bold shadow-sm" (click)="onSave()">💾 Aplicar Cambios</button>
  </div>
</div>